module.exports = __webpack_public_path__ + "static/media/bcsswami.97afde92.webp";